import { images } from "../../assets/Images/assetsImages"

const HeroSection = ({ heroData }) => {

    const data = heroData[0];

  return (
    <section className="w-full h-screen flex bg-[#F5E9D7] relative items-center justify-center">
        <div className="w-full lg:w-[50%] h-full flex items-center justify-center">
            <div className="w-[80%] text-center lg:text-start">
                <h1 className="font-bold font-playfair text-6xl text-[#41220E] mb-[30px]">{data.title}</h1>
                <p className="font-normal font-montserrat text-xl text-[#41220E]">{data.content}</p>
            </div>
        </div>
        <div className="absolute inset-0 left-[10%] sm:left-[20%] lg:left-0 top-[10%] xl:top-[15%] w-[70%] sm:w-[55%] lg:w-[45%] opacity-10">
            <img src={images.LogoBackground} alt="Logo" className="w-full h-full"></img>
        </div>
        <div className="hidden lg:flex w-[700px] h-[700px] rounded-full mt-[120px]"
            style={{
                backgroundImage: `url(${data.image})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
            }}>
        </div>
    </section>
  )
}

export default HeroSection
